import { tableHeadWithdrawal } from './constants';

export const getFlex = (index: number) => {
  const currentHead = tableHeadWithdrawal.find((_, i) => i === index);
  return currentHead?.flex || 1;
};
